import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ObservationService {
  private _profileSubject = new Subject<number>();
  private _profileRelationSubject = new Subject<number>();
  private _applyBatchPaymentSubject = new Subject();
  private _committeeSubject = new Subject<number>();
  private _massCommProfilesTabSubject = new Subject<boolean>();

  constructor() {}

  // #region Observables

  public observeProfiles(): Observable<number> {
    return this._profileSubject.asObservable();
  }

  public observeProfileRelations(): Observable<number> {
    return this._profileRelationSubject.asObservable();
  }

  public observeApplyBatchPayment(): Observable<any> {
    return this._applyBatchPaymentSubject.asObservable();
  }

  public observeCommittees(): Observable<number> {
    return this._committeeSubject.asObservable();
  }

  public observeMassCommProfilesTabSelected(): Observable<boolean> {
    return this._massCommProfilesTabSubject.asObservable();
  }
  // #endregion

  // #region Emit Next Methods
  public profileUpdated(id: number) {
    this._profileSubject.next(id);
  }

  public relationAdded(id: number) {
    this._profileRelationSubject.next(id);
  }

  public applyBatchPayment() {
    this._applyBatchPaymentSubject.next(null);
  }

  public committeeUpdated(id: number) {
    this._committeeSubject.next(id);
  }

  public massCommProfilesTabSelected() {
    this._massCommProfilesTabSubject.next(true);
  }
  // #endregion
}
